import { ContentFilters, ContentTopBar } from "components";
import dayjs from "dayjs";
import { useUserContext } from "features/users";
import { SuperFilterForm } from "features/withdraw/components/super-admin-filter/super-with-admin-filter-form";
import { SuperAdminTable } from "features/withdraw/components/super-admin-table/super-with-admin-table";
import {
  UsersWithWithdrawFilterFormPaginated,
  UsersWithWithdrawFilterFormValues,
} from "features/withdraw/components/users-with-wallet-filter-form/type";
import { useGetUsersWithWithdraw } from "features/withdraw/use-cases/get-withdraw";
import { usePaginationParams } from "hooks";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";
import { formatDate } from "utils/date";
const initialFilterValues: UsersWithWithdrawFilterFormValues = {
  user_name: undefined,
  phone_number: undefined,
  refrence_no: undefined,
  status_id: undefined,
  remark: undefined,
  date: null,
  auth: undefined,
  tranid: undefined,
  transactionDate: null,
  amount: undefined,
};

export const SuperAdminView = () => {
  const { user } = useUserContext();
  const navigate = useNavigate();

  const [queryFilters, setQueryFilters] = useState<any>(initialFilterValues);
  const fromDate = queryFilters.date?.[0];
  const toDate = queryFilters.date?.[1];
  const transactionFromDate = queryFilters.transactionDate?.[0];
  const transactionToDate = queryFilters.transactionDate?.[1];
  const { params, updateParams, resetPage } =
    usePaginationParams<UsersWithWithdrawFilterFormPaginated>({
      page: 1,
      size: 10,
      order_by_transaction: "-last_transaction_date",
      ...initialFilterValues,
    });

  const [transactionAmountFrom, transactionAmountTo] = (() => {
    if (!queryFilters?.amount) return [undefined, undefined];
    const amountStr = queryFilters.amount.toString().trim();
    if (amountStr.includes("+")) {
      const from = amountStr.replace(/[^0-9.]/g, "");

      return [from || undefined, undefined];
    }
    const parts = amountStr.split(/[\s\-_,]+/);
    if (parts.length >= 2) {
      return [parts[0], parts[1]];
    }
    if (parts.length === 1 && parts[0] !== "") {
      return [parts[0].replace(/[^0-9.]/g, ""), undefined];
    }

    return [undefined, undefined];
  })();

  const { data, isFetching } = useGetUsersWithWithdraw(
    {
      page: params.page,
      size: params.size,
      adminuser: "superadmin",
      from_date: fromDate
        ? formatDate({
            date: dayjs(fromDate).startOf("day"),
            format: "isoDate",
          })
        : undefined,
      to_date: toDate
        ? formatDate({
            date: dayjs(toDate).endOf("day"),
            format: "isoDate",
          })
        : undefined,
      transaction_From_Date: transactionFromDate
        ? formatDate({
            date: dayjs(transactionFromDate).startOf("day"),
            format: "isoDate",
          })
        : undefined,
      transaction_To_Date: transactionToDate
        ? formatDate({
            date: dayjs(transactionToDate).endOf("day"),
            format: "isoDate",
          })
        : undefined,

      phone_number: queryFilters.phone_number,
      user_name: queryFilters.user_name,
      auth: queryFilters?.auth,
      transaction_amount_from: transactionAmountFrom,
      transaction_amount_to: transactionAmountTo,

      tranid: queryFilters?.tranid,
      refrence_no: queryFilters.refrence_no,
      status_id: queryFilters.status_id,
    } as any,
    {
      retry: false,
    }
  );

  const handleFiltersChange = (values: UsersWithWithdrawFilterFormValues) => {
    setQueryFilters(values);
    updateParams(values);
    resetPage();
  };

  useEffect(() => {
    if (user?.role && user.role == "Li3ibAccountant") {
      navigate(ROUTES.WITHDRAW);
    }
  }, [user, data]);

  const formId = "users-with-wallet-filters-form";

  return (
    <>
      <ContentTopBar title={"Super Admin"} />

      <ContentFilters formId={formId}>
        <SuperFilterForm
          formId={formId}
          setQueryFilters={setQueryFilters}
          handleFilter={handleFiltersChange}
          initialValues={initialFilterValues}
        />
      </ContentFilters>

      <SuperAdminTable
        isLoading={isFetching}
        data={data}
        tableParams={params}
        updateParams={updateParams}
      />

      <Outlet />
    </>
  );
};
